<template>
  <div id="cup_scheduleDetail" v-show="currThemeObj">
    <div class="abs_top">
      <scheduleDetail_matchPanel
        :currThemeObj="currThemeObj"
        :matchInfor="matchPanel_matchInfor"
        :matchEventList="matchPanel_matchEventList"
        @eventItemShowTipClickEvent="eventItemShowTipHandler"
      ></scheduleDetail_matchPanel>
      <div class="selectTab_area">
        <selectTab
          :currThemeObj="currThemeObj"
          :tabArr="tabArr"
          :pageJumpParams="selectTab_pageJumpParams"
          @clickTabEvent="onChangeTab"
        ></selectTab>
      </div>
    </div>
    <div>
      <router-view
        :axiosBaseUrl="axiosBaseUrl"
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :matchInfor="matchPanel_matchInfor"
        :isRefresh="isRefresh"
        :refreshTime="refreshTime"
        :curTimeZoneItem="curTimeZoneItem"
      ></router-view>
    </div>
  </div>
</template>

<script>
import scheduleDetail_matchPanel from './scheduleDetail_matchPanel'
import selectTab from '@components/platfromBase/compreSportsMeet/selectTab.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'

import { https_cup_scheduleAIForwardLooking, https_cup_scheduleDetail } from '@api/platfrom_football_api'
export default {
  name: 'cup_scheduleDetail',
  components: { scheduleDetail_matchPanel, selectTab },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      isRefresh: false, //是否需要实时更新
      refreshTime: 15 * 1000,
      setIntervalId: null,
      matchPanel_matchInfor: {
        matchStatus: null,
        homeId: '',
        homeName: '',
        homeScore: '',
        homePoint: null,
        homeLogo: '',
        awayId: '',
        awayName: '',
        awayScore: '',
        awayPoint: null,
        awayLogo: '',
        venueId: '',
        venueName: '',
      },
      currMatchStatus: null, // Playing || Suspended
      tabArr: [
        {
          name: 'AI前瞻',
          id: 'ai',
          pathName: 'scheduleDetailAIForwardLooking',
          act: true,
        },
        {
          name: '赛前',
          id: 'preMatch',
          pathName: 'scheduleDetailPreMatch',
          act: true,
        },
        {
          name: '阵容',
          id: 'lineup',
          pathName: 'scheduleDetailLineup',
          act: false,
        },
        {
          name: '数据分析',
          id: 'analysis',
          pathName: 'scheduleDetailAnalysis',
          act: false,
        },
        {
          name: '数据统计',
          id: 'statistics',
          pathName: 'scheduleDetailStatistics',
          act: false,
        },
      ],
      selectTab_pageJumpParams: [],
      matchPanel_matchEventList: null,
    }
  },
  watch: {
    isRefresh(newVal, oldVal) {
      console.debug(`lineup isRefresh: ${newVal}, ${oldVal}`)
      if (newVal && !oldVal) {
        this.refreshCallbackHandle()
      } else if (!newVal && oldVal) {
        this.cancelRefreshCallBackHandle()
      }
    },
  },
  created() {
    if (this.currThemeObj) {
      this.tabArr.forEach((item) => {
        item.pathName = `${item.pathName}_${this.currThemeObj.moduleRouteNameEn}` // teamDetailPlayerList_FIFAWC
      })
    }
    this.query = this.$route.query
    if (this.query) {
      this.init()
    }
  },
  methods: {
    async init() {
      // this.origin_matchList = matchList_mock.dat
      await this.getScheduleDetail(this.query)
    },
    cancelRefreshCallBackHandle() {
      clearInterval(this.setIntervalId)
      this.setIntervalId = null
    },
    refreshCallbackHandle() {
      const query = this.$route.query
      this.setIntervalId = setInterval(() => {
        if (query) {
          this.getScheduleDetail(query)
        }
      }, this.refreshTime - 0)
    },
    onChangeTab(item) {
      this.tabArr.forEach((tabItem) => {
        if (item.id == tabItem.id) {
          tabItem.act = true
        } else {
          tabItem.act = false
        }
      })
    },
    eventItemShowTipHandler(data) {
      let matchEventList = this.matchEventList
      this.matchEventList = matchEventList.map((item) => {
        if (data.eventId == item.eventId) {
          item.isShowTip = !data.isShowTip
        }
        return item
      })
      this.updateMatchEventList()
      // console.debug(matchEventList)
      // this.matchEventList = matchEventList
    },
    updateMatchEventList() {
      let matchEventList = []
      if (
        !this.currMatchStatus ||
        this.currMatchStatus === 'Cancelled' ||
        this.currMatchStatus === 'Fixture' ||
        this.currMatchStatus === 'Postponed'
      ) {
        // 取消，排赛，推迟 不展示时间条，所以返回[]
        return matchEventList
      }

      // matchEventList = [
      //   {
      //     eventId: 1,
      //     homeAway: 'HOME',
      //     eventType: 'goalEvent',
      //     name: '球员c',
      //     timeText: '14′',
      //     eventTime: 14,
      //     totalTime: 90,
      //     timePer: (14 / 90).toFixed(4) * 100,
      //   },
      //   {
      //     eventId: 2,
      //     homeAway: 'AWAY',
      //     eventType: 'redCardEvent',
      //     name: '球员d',
      //     timeText: '25′',
      //     eventTime: 25,
      //     totalTime: 90,
      //     timePer: (25 / 90).toFixed(4) * 100,
      //   },
      // ]
      matchEventList = this.matchEventList
      console.debug('change list')
      if (
        this.currMatchStatus === 'Played' &&
        matchEventList[matchEventList.length - 1].eventType !== 'endEvent'
      ) {
        // 比赛结束且没有添加过结束事件的增加该事件
        matchEventList.push({
          eventId: matchEventList[matchEventList.length - 1].eventId + 1,
          eventType: 'endEvent',
          isShowTip: false,
          name: '',
          timeText: '终',
          eventTime: this.totalTime,
          totalTime: this.totalTime,
          timePer: 100,
        })
      }
      this.matchPanel_matchEventList = matchEventList
    },
    async getScheduleDetail(query) {
      await https_cup_scheduleDetail(this.axiosBaseUrl, this.$axios, query)
        .then((response) => {
          const res = response.data
          console.debug('res:', res)
          if (res.status === 0) {
            const paramsItem = res.data.matchInfo

            this.matchPanel_matchInfor = {
              matchStatus: paramsItem.matchStatus,
              homeId: paramsItem.homeId,
              homeName: paramsItem.homeName,
              homeScore: paramsItem.homeScore !== null ? paramsItem.homeScore - paramsItem.homePoint : null,
              homePoint: paramsItem.homePoint,
              homeLogo: paramsItem.homeLogo,
              awayId: paramsItem.awayId,
              awayName: paramsItem.awayName,
              awayScore: paramsItem.awayScore !== null ? paramsItem.awayScore - paramsItem.awayPoint : null,
              awayPoint: paramsItem.awayPoint,
              awayLogo: paramsItem.awayLogo,
              venueId: paramsItem.venueId,
              venueName: paramsItem.venueName,
            }
            this.currMatchStatus = paramsItem.matchStatus
            if (
              paramsItem.matchStatus == 'Playing' ||
              paramsItem.matchStatus == 'Suspended'
            ) {
              // 比赛进行 || 暂停 状态
              this.isRefresh = true
            } else {
              this.isRefresh = false
            }
            // this.isRefresh = true //测试

            // 为了测试赛前这里暂时注释掉
            // if (
            //   paramsItem.matchStatus == 'Playing' ||
            //   paramsItem.matchStatus == 'Suspended' ||
            //   paramsItem.matchStatus == 'Played'
            // ) {
            //   if (this.$route.name == `scheduleDetailPreMatch_${this.currThemeObj.moduleRouteNameEn}`) {
            //     // 如果比赛进行时或者比赛结束时，进入赛前tab的默认进入阵容tab
            //     console.debug(this.$route)
            //     this.$router.replace({
            //       name: `scheduleDetailLineup_${this.currThemeObj.moduleRouteNameEn}`,
            //       query: query,
            //     })
            //   }
            //   setTimeout(() => {
            //     this.tabArr = [
            //       {
            //         name: '阵容',
            //         id: 'lineup',
            //         pathName: `scheduleDetailLineup_${this.currThemeObj.moduleRouteNameEn}`,
            //         act: true,
            //       },
            //       {
            //         name: '数据分析',
            //         id: 'analysis',
            //         pathName: `scheduleDetailAnalysis_${this.currThemeObj.moduleRouteNameEn}`,
            //         act: false,
            //       },
            //       {
            //         name: '数据统计',
            //         id: 'statistics',
            //         pathName: `scheduleDetailStatistics_${this.currThemeObj.moduleRouteNameEn}`,
            //         act: false,
            //       },
            //     ]
            //   }, 10)
            // }

            this.totalTime = paramsItem.overtime
            let matchEventList = [].concat(
              res.data.homeEvents,
              res.data.awayEvents
            )

            matchEventList.forEach((item) => {
              item.timeTotalSec = item.timeMin * 60 + item.timeSec
            })
            matchEventList.sort((a, b) => {
              return a.timeTotalSec - b.timeTotalSec
            })
            if (matchEventList.length > 0) {
              this.matchEventList = matchEventList.map((item, itemIndex) => {
                const totalTime =
                  paramsItem.overtime > res.data.maxMin
                    ? paramsItem.overtime
                    : res.data.maxMin //最后一个事件时间（不含点球大战里面的）
                let eventType = ''
                if (item.eventCode == 1) {
                  // 乌龙球
                  eventType = 'ownGoalEvent'
                } else if (item.eventCode == 2) {
                  // 进球
                  eventType = 'goalEvent'
                } else if (item.eventCode == 3) {
                  // 换人
                  eventType = ''
                } else if (item.eventCode == 5) {
                  // 黄牌
                  eventType = 'yellowCardEvent'
                } else if (item.eventCode == 4) {
                  // 红牌
                  eventType = 'redCardEvent'
                } else if (item.eventCode == 6) {
                  // 点球
                  eventType = 'pointIntoEvent'
                } else {
                }
                return {
                  eventCode: item.eventCode,
                  eventId: itemIndex,
                  isShowTip: false,
                  homeAway: item.homeAway,
                  eventType,
                  name: item.playerName,
                  timeText: `${item.timeMin}′`,
                  eventTime: item.timeMin,
                  totalTime,
                  timePer: (item.timeMin / totalTime).toFixed(4) * 100,
                }
              })
              console.debug('matchEventList:', matchEventList)
              this.updateMatchEventList()
            }

            this.selectTab_pageJumpParams = [query, paramsItem]
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.matchPanel_matchInfor = {
                matchStatus: '',
                homeId: '',
                homeName: '',
                homeScore: '',
                homeLogo: '',
                awayId: '',
                awayName: '',
                awayScore: '',
                awayLogo: '',
                venueId: '',
                venueName: '',
              }
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getScheduleAIForwardLooking(query) {
      await https_cup_scheduleAIForwardLooking(this.axiosBaseUrl, this.$axios, query)
        .then((response) => {
          const res = response.data
          console.debug('res:', res)
          if (res.status === 0) {
            const paramsItem = res.data.matchInfo

            this.matchPanel_matchInfor = {
              matchStatus: paramsItem.matchStatus,
              homeId: paramsItem.homeId,
              homeName: paramsItem.homeName,
              homeScore: paramsItem.homeScore,
              homePoint: paramsItem.homePoint,
              homeLogo: paramsItem.homeLogo,
              awayId: paramsItem.awayId,
              awayName: paramsItem.awayName,
              awayScore: paramsItem.awayScore,
              awayPoint: paramsItem.awayPoint,
              awayLogo: paramsItem.awayLogo,
              venueId: paramsItem.venueId,
              venueName: paramsItem.venueName,
            }
            this.currMatchStatus = paramsItem.matchStatus
            if (
              paramsItem.matchStatus == 'Playing' ||
              paramsItem.matchStatus == 'Suspended'
            ) {
              // 比赛进行 || 暂停 状态
              this.isRefresh = true
            } else {
              this.isRefresh = false
            }
            // this.isRefresh = true //测试

            // 为了测试赛前这里暂时注释掉
            // if (
            //   paramsItem.matchStatus == 'Playing' ||
            //   paramsItem.matchStatus == 'Suspended' ||
            //   paramsItem.matchStatus == 'Played'
            // ) {
            //   if (this.$route.name == `scheduleDetailPreMatch_${this.currThemeObj.moduleRouteNameEn}`) {
            //     // 如果比赛进行时或者比赛结束时，进入赛前tab的默认进入阵容tab
            //     console.debug(this.$route)
            //     this.$router.replace({
            //       name: `scheduleDetailLineup_${this.currThemeObj.moduleRouteNameEn}`,
            //       query: query,
            //     })
            //   }
            //   setTimeout(() => {
            //     this.tabArr = [
            //       {
            //         name: '阵容',
            //         id: 'lineup',
            //         pathName: `scheduleDetailLineup_${this.currThemeObj.moduleRouteNameEn}`,
            //         act: true,
            //       },
            //       {
            //         name: '数据分析',
            //         id: 'analysis',
            //         pathName: `scheduleDetailAnalysis_${this.currThemeObj.moduleRouteNameEn}`,
            //         act: false,
            //       },
            //       {
            //         name: '数据统计',
            //         id: 'statistics',
            //         pathName: `scheduleDetailStatistics_${this.currThemeObj.moduleRouteNameEn}`,
            //         act: false,
            //       },
            //     ]
            //   }, 10)
            // }

            this.totalTime = paramsItem.overtime
            let matchEventList = [].concat(
              res.data.homeEvents,
              res.data.awayEvents
            )

            matchEventList.forEach((item) => {
              item.timeTotalSec = item.timeMin * 60 + item.timeSec
            })
            matchEventList.sort((a, b) => {
              return a.timeTotalSec - b.timeTotalSec
            })
            if (matchEventList.length > 0) {
              this.matchEventList = matchEventList.map((item, itemIndex) => {
                const totalTime =
                  paramsItem.overtime > res.data.maxMin
                    ? paramsItem.overtime
                    : res.data.maxMin //最后一个事件时间（不含点球大战里面的）
                let eventType = ''
                if (item.eventCode == 1) {
                  // 乌龙球
                  eventType = 'ownGoalEvent'
                } else if (item.eventCode == 2) {
                  // 进球
                  eventType = 'goalEvent'
                } else if (item.eventCode == 3) {
                  // 换人
                  eventType = ''
                } else if (item.eventCode == 5) {
                  // 黄牌
                  eventType = 'yellowCardEvent'
                } else if (item.eventCode == 4) {
                  // 红牌
                  eventType = 'redCardEvent'
                } else if (item.eventCode == 6) {
                  // 点球
                  eventType = 'pointIntoEvent'
                } else {
                }
                return {
                  eventCode: item.eventCode,
                  eventId: itemIndex,
                  isShowTip: false,
                  homeAway: item.homeAway,
                  eventType,
                  name: item.playerName,
                  timeText: `${item.timeMin}′`,
                  eventTime: item.timeMin,
                  totalTime,
                  timePer: (item.timeMin / totalTime).toFixed(4) * 100,
                }
              })
              console.debug('matchEventList:', matchEventList)
              this.updateMatchEventList()
            }

            this.selectTab_pageJumpParams = [query, paramsItem]
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.matchPanel_matchInfor = {
                matchStatus: '',
                homeId: '',
                homeName: '',
                homeScore: '',
                homeLogo: '',
                awayId: '',
                awayName: '',
                awayScore: '',
                awayLogo: '',
                venueId: '',
                venueName: '',
              }
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#cup_scheduleDetail {
  padding-top: 20.833vw;
  .abs_top {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 0 9.722vw;
    width: 100%;
    height: 20.833vw;
    color: var(--mixtmt_whiteColor);
    background-image: var(--mixtmt_scheduleDetail_banner);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    object-fit: contain;
    .selectTab_area {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      padding: 0 9.722vw;
      width: 100%;
      height: 2.778vw;
    }
  }
}
</style>
